import { render, staticRenderFns } from "./customizeView.vue?vue&type=template&id=9458430a&scoped=true"
import script from "./customizeView.vue?vue&type=script&lang=js"
export * from "./customizeView.vue?vue&type=script&lang=js"
import style0 from "./customizeView.vue?vue&type=style&index=0&id=9458430a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9458430a",
  null
  
)

export default component.exports